import { render, staticRenderFns } from "./AnimeDetails.vue?vue&type=template&id=3763f597&scoped=true&"
import script from "./AnimeDetails.vue?vue&type=script&lang=js&"
export * from "./AnimeDetails.vue?vue&type=script&lang=js&"
import style0 from "./AnimeDetails.vue?vue&type=style&index=0&id=3763f597&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763f597",
  null
  
)

export default component.exports